import React from "react";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { connect } from "react-redux";
import { Logo } from "../profile/logo";
import { FullName } from "../profile/full-name";
import { ModalFooter, Submit } from "../../../react-components/modals/modal-form-elements";
import {
  ProfileImage,
  OnBoardingEnthusiastAction,
  ProfileModuleState,
  EditProfilePayload,
  EditProfileAction,
} from "../redux/profile/types";
import { setProfileState, onBoardingEnthusiast, editProfile } from "../redux/profile/actions";
import { AppState } from "../../../redux";

interface MapStateProps {
  profileImage: ProfileImage;
  fullName: string;
  inProgress: boolean;
  user: Person;
}

interface MapDispatchProps {
  editProfile: (payload: EditProfilePayload) => EditProfileAction;
  onBoardingEnthusiast: () => OnBoardingEnthusiastAction;
}

type Props = MapDispatchProps & MapStateProps;

const Component = (props: Props) => {
  const { user, fullName, inProgress, editProfile, onBoardingEnthusiast } = props;
  const title = "Create your Entrepreneurial enthusiast profile.";

  const hasAtLeastTwoNames = /\w +\w/.test(fullName);
  const isValid = hasAtLeastTwoNames;

  React.useEffect(() => {
    if (!user) {
      return;
    }
    editProfile({ subject: user });
  }, [editProfile, user]);

  const onSubmit = React.useCallback(() => {
    onBoardingEnthusiast();
  }, [onBoardingEnthusiast]);

  return (
    <Container>
      <div className="subtitle">{title}</div>
      <Logo isRequired={false} />
      <FullName />
      <ModalFooter>
        <Submit
          onClick={onSubmit}
          disabled={false}
          className={isValid ? `` : "disabled"}
          isSubmitting={inProgress}
          title="Continue"
        />
      </ModalFooter>
    </Container>
  );
};

const Container = ({ children }) => {
  return <div className="onboarding-enthusiast">{children}</div>;
};

const mapState = (state: AppState & ProfileModuleState) => ({
  user: state.account.user,
  profileImage: state.profile.profileImage,
  fullName: state.profile.fullName,
  inProgress: state.cache.inProgress["onboarding-enthusiast"],
});

const mapDispatch = {
  setProfileState,
  editProfile: editProfile,
  onBoardingEnthusiast,
};

export const OnBoardingEnthusiast = connect(mapState, mapDispatch)(Component);
